<template>
  <div>
    <vx-card class="mb-4">
      <form-detail-include :id="id" ></form-detail-include>

      <comments-include :newsletterId="id" :comments.sync="comments" :showHandling="true"></comments-include>

      <div class="w-full flex gap-2 justify-end">
        <b-button
          variant="outline-secondary"
          class="float-right"
          @click="goBack">
          <feather-icon
            icon="CornerUpLeftIcon"
            class="mr-50"/>
          <span class="align-middle">{{$t('back')}}</span>
        </b-button>
      </div>
    </vx-card>
  </div>
</template>

<script>

import { isAdmin } from '@/util/Util'
import {
  BRow,
  BCol,
  BCardText,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue'

import NewsletterService from '@/services/api/NewsletterService'
import CommentsInclude from '../CommentsInclude.vue'
import FormDetailInclude from '../FormDetailInclude.vue'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BCardText,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
    CommentsInclude,
    FormDetailInclude,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    service: null,
    comments: [],
  }),
  computed: {

  },
  beforeMount() {
    this.service = NewsletterService.build(this.$vs)

  },
  mounted() {
    if (this.id) {
      this.loadComments(this.id)
    }
  },
  beforeDestroy() {
    this.destroyChilds(this)
  },
  methods: {
    loadComments(id) {
      this.$vs.loading()
      this.service.loadCommentsByNewsletter(id).then(
        response => {
          this.comments = response
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    },
    goBack() {
      this.$router.push('/newsletters-moderator')
    },
    isAdmin() {
      return isAdmin()
    },
  }
}
</script>

<style>

</style>
